import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SideBarService {
  public isShowSidebar = new BehaviorSubject<boolean>(false);
  constructor() {}

  open() {
    this.isShowSidebar.next(true);
  }

  close() {
    this.isShowSidebar.next(false);
  }
}
